import { truncateWHT } from "./formatters";

export function handleExportDataLocal(data, type, usdThb = 34.5) {
  if (!data || !data.length) return;
  let csv = "\uFEFF";
  if (type === "dividends") csv += "Date,Stock,Gross,WHT,Net\n";
  else if (type === "capital") csv += "Date,Type,Amount\n";
  else if (type === "holdings") csv += "Stock,Units,Avg Price,Live Price,Value (USD),Value (THB),Cost Basis,P/L (USD),P/L (%),Daily Change\n";
  else if (type === "realized_pl") csv += "Date & Time,Stock,FX Rate,Profit (USD),Profit (THB)\n";
  else csv += "Date,Stock,Type,Units,Price,Gross Amount,FX Rate,Commission,VAT,SEC Fee,TAF Fee,Total Net\n";

  data.forEach((item) => {
    if (type === "dividends") {
      const date_dividend = item.Date_Dividend ?? item.date_dividend ?? item.date ?? "";
      const id_stock = item.ID_Stock ?? item.id_stock ?? item.symbol ?? "";
      const dividend_amount = item.Dividend_Amount ?? item.dividend_amount ?? item.gross ?? 0;
      const wht_15 = item.WHT_15 ?? item.wht_15 ?? item.wht ?? 0;
      const total_amount = item.Total_Amount ?? item.total_amount ?? item.net ?? 0;
      csv += `${date_dividend},${id_stock},${dividend_amount},${wht_15},${total_amount}\n`;
    }
    else if (type === "capital") {
      const date_transaction = item.Date_Transaction ?? item.date_transaction ?? item.date ?? "";
      const cp_type = item.Type ?? item.type ?? "";
      const amount_usd = item.Amount_USD ?? item.amount_usd ?? item.amount ?? 0;
      csv += `${date_transaction},${cp_type},${amount_usd}\n`;
    }
    else if (type === "holdings") {
      const symbol        = item["Stock"]        ?? item.symbol       ?? item.Symbol      ?? "";
      const units         = item["Units"]        ?? item.units        ?? item.totalUnits  ?? 0;
      const avg_price     = item["Avg Price"]    ?? item.avgPrice     ?? item.avg_price   ?? 0;
      const current_price = item["Live Price"]   ?? item.currentPrice ?? item.current_price ?? 0;
      const market_value  = item["Value (USD)"]  ?? item.marketValue  ?? item.market_value  ?? 0;
      const value_thb     = item["Value (THB)"]  ?? 0;
      const cost_basis    = item["Cost Basis"]   ?? item.totalCostBasis ?? 0;
      const pl_usd        = item["P/L (USD)"]    ?? 0;
      const pl_pct        = item["P/L (%)"]      ?? item.gainLossPercent ?? 0;
      const daily_change  = item["Daily Change"] ?? item.dailyChange  ?? 0;
      csv += `${symbol},${units},${avg_price},${current_price},${market_value},${value_thb},${cost_basis},${pl_usd},${pl_pct},${daily_change}\n`;
    }
    else if (type === "realized_pl") {
      const date_transaction = item.Date_Transaction ?? item.date_transaction ?? item.date ?? "";
      const id_stock = item.ID_Stock ?? item.id_stock ?? item.symbol ?? "";
      const fx_rate = item.FX_Rate ?? item.fx_rate ?? 0;
      const realized_pl = item.realizedPL ?? item.realized_pl ?? item.Realized_PL ?? 0;
      csv += `${date_transaction},${id_stock},${fx_rate},${realized_pl},${realized_pl * (fx_rate || usdThb)}\n`;
    }
    else {
      const date_transaction = item.Date_Transaction ?? item.date_transaction ?? item.date ?? "";
      const id_stock = item.ID_Stock ?? item.id_stock ?? item.symbol ?? item.stock ?? "";
      const tx_type = item.Type ?? item.type ?? "Buy";
      const amount_stock = item.Amount_Stock ?? item.amount_stock ?? item.units ?? item.shares ?? 0;
      const price = item.Price ?? item.price ?? 0;
      const gross_amount = item.Gross_Amount ?? item.gross_amount ?? 0;
      const fx_rate = item.FX_Rate ?? item.fx_rate ?? 0;
      const commission = item.Commission ?? item.commission ?? 0;
      const vat = item.VAT ?? item.vat ?? 0;
      const sec_fee = item.SEC_Fee ?? item.sec_fee ?? 0;
      const taf_fee = item.TAF_Fee ?? item.taf_fee ?? 0;
      const total_amount = item.Total_Amount ?? item.total_amount ?? item.total_value ?? 0;
      csv += `${date_transaction},${id_stock},${tx_type},${amount_stock},${price},${gross_amount},${fx_rate},${commission},${vat},${sec_fee},${taf_fee},${total_amount}\n`;
    }
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Portfolio_${type}_${new Date().toISOString().split("T")[0]}.csv`;
  link.click();
}

export function parseImportDate(dateStr) {
  if (!dateStr) return new Date().toISOString().split("T")[0];
  dateStr = dateStr.replace(/^\uFEFF/, "").trim();
  let year, month, day;
  if (dateStr.includes("-")) [year, month, day] = dateStr.split("-");
  else if (dateStr.includes("/")) [day, month, year] = dateStr.split("/");
  if (year && month && day) {
    let y = parseInt(year);
    if (y > 2400) y -= 543;
    return `${y}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  return dateStr;
}

export async function handleImportDataLocal(e, type, supabase, userId, setNotification, onSuccess, checkLimit) {
  const file = e.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = async (event) => {
    try {
      let text = event.target.result.replace(/^\uFEFF/, "");
      const lines = text.split(/\r\n|\n/).filter((line) => line.trim() !== "");
      if (lines.length < 2) return;
      if (!checkLimit()) { e.target.value = null; return; }

      function parseCSVRow(str) {
        const arr = []; let quote = false; let val = "";
        for (let i = 0; i < str.length; i++) {
          let cc = str[i], nc = str[i + 1];
          if (cc === '"' && quote && nc === '"') { val += '"'; i++; continue; }
          if (cc === '"') { quote = !quote; continue; }
          if (cc === "," && !quote) { arr.push(val.trim()); val = ""; continue; }
          val += cc;
        }
        arr.push(val.trim()); return arr;
      }

      let headers = parseCSVRow(lines[0]).map((h) => h.toLowerCase());
      const findIdx = (kw) => headers.findIndex((h) => kw.some((k) => h.includes(k)));

      let payloads = [];
      let tableName = "";

      const idxD = findIdx(["date"]);
      const idxS = findIdx(["stock", "symbol"]);
      const idxT = findIdx(["type"]);
      const idxU = findIdx(["units", "amount_stock", "shares", "amount"]);
      const idxP = findIdx(["price"]);
      const idxG = findIdx(["gross"]);
      const idxFX = findIdx(["fx", "rate"]);
      const idxComm = findIdx(["comm"]);
      const idxVat = findIdx(["vat"]);
      const idxSec = findIdx(["sec"]);
      const idxTaf = findIdx(["taf"]);
      const idxN = findIdx(["net", "total"]);
      const idxW = findIdx(["wht", "tax"]);
      // ── FIX: idxA ไม่เคยถูกประกาศมาก่อน ทำให้ import "capital" throw
      // ReferenceError ทุกครั้ง (idxA > -1 อ้างถึงตัวแปรที่ไม่มีอยู่) ──
      const idxA = findIdx(["amount"]);

      for (let i = 1; i < lines.length; i++) {
        const cols = parseCSVRow(lines[i]);
        if (cols.length < 2) continue;
        let payload = null;
        const cleanNum = (str) => str ? Number(str.replace(/,/g, "")) : 0;

        if (type === "transactions") {
          if (idxD > -1 && idxS > -1 && idxU > -1) {
            const txTypeRaw = idxT > -1 ? cols[idxT] : "Buy";
            const upperType = txTypeRaw.toUpperCase();

            const cleanType = (upperType.includes("BUY") || txTypeRaw === "ซื้อ") ? "Buy" :
                              (upperType.includes("SPLIT") ? "Split" :
                              (upperType.includes("ADJUST") ? "Adjust" : "Sell"));

            const rawUnits = cleanNum(cols[idxU]);
            const u = cleanType === "Adjust" ? rawUnits : Math.abs(rawUnits);
            const p = Math.abs(cleanNum(cols[idxP]));
            const gross = idxG > -1 ? Math.abs(cleanNum(cols[idxG])) : Number((u * p).toFixed(4));
            const rawNet = cleanNum(cols[idxN]);

            const isNonPriceTx = (cleanType === "Split" || cleanType === "Adjust");

            payload = {
              user_id: userId,
              date_transaction: parseImportDate(cols[idxD]),
              id_stock: cols[idxS].toUpperCase(),
              type: cleanType,
              amount_stock: Number(u.toFixed(7)),
              price: isNonPriceTx ? 0 : Number(p.toFixed(4)),
              gross_amount: isNonPriceTx ? 0 : gross,
              fx_rate: idxFX > -1 ? cleanNum(cols[idxFX]) : (cleanType === "Split" ? 1 : 0),
              commission: idxComm > -1 ? cleanNum(cols[idxComm]) : 0,
              vat: idxVat > -1 ? cleanNum(cols[idxVat]) : 0,
              sec_fee: idxSec > -1 ? cleanNum(cols[idxSec]) : 0,
              taf_fee: idxTaf > -1 ? cleanNum(cols[idxTaf]) : 0,
              total_amount: cleanType === "Adjust"
                ? (idxN > -1 ? rawNet : 0)
                : (isNonPriceTx ? 0 : (idxN > -1 && rawNet !== 0 ? Math.abs(rawNet) : gross)),
              last_updated: new Date().toISOString()
            };
            tableName = "transactions";
          }
        } else if (type === "dividends") {
          if (idxD > -1 && idxS > -1) {
            const gross = Math.abs(cleanNum(cols[idxG]));
            const wht = idxW > -1 ? Math.abs(cleanNum(cols[idxW])) : truncateWHT(gross);
            const net = idxN > -1 ? Math.abs(cleanNum(cols[idxN])) : Number((gross - wht).toFixed(2));
            payload = {
              user_id: userId,
              date_dividend: parseImportDate(cols[idxD]),
              id_stock: cols[idxS].toUpperCase(),
              dividend_amount: gross,
              wht_15: wht,
              total_amount: net,
            };
            tableName = "dividends";
          }
        } else if (type === "capital") {
          if (idxD > -1 && idxA > -1) {
            const capTypeRaw = idxT > -1 ? cols[idxT] : "Deposit";
            payload = {
              user_id: userId,
              date_transaction: parseImportDate(cols[idxD]),
              type: (capTypeRaw.toLowerCase().includes("withdraw") || capTypeRaw === "ถอน") ? "Withdrawal" : "Deposit",
              amount_usd: Math.abs(cleanNum(cols[idxA])),
            };
            tableName = "capitals";
          }
        }

        if (payload && tableName) {
          payloads.push(payload);
        }
      }

      if (payloads.length > 0) {
        const { error } = await supabase
          .from(tableName)
          .insert(payloads);

        if (error) throw error;

        if (setNotification) setNotification(`สำเร็จ! นำเข้าข้อมูลแล้ว ${payloads.length} รายการ`);
        if (onSuccess) onSuccess();
      } else {
        if (setNotification) setNotification("นำเข้า 0 รายการ (ตรวจสอบไฟล์)");
      }

    } catch (err) {
      console.error("Import Error:", err);
      if (setNotification) setNotification("เกิดข้อผิดพลาดในการนำเข้าข้อมูลลงฐานข้อมูล");
    }
  };
  reader.readAsText(file);
  e.target.value = null;
}
